<template>
    <div class="container">
        <div class="columns">
            <div class="column is-4 is-offset-4">
                <h1 class="title">Sign up</h1>
            
                <form @submit.prevent="submitForm">
                    <div class="field">
                        <label>Email</label>
                        <div class="control">
                            <input type="email" name="email" class="input" v-model="username">
                        </div>
                    </div>


                    <div class="field">
                        <label>Password</label>
                        <div class="control">
                            <input type="password" name="password1" class="input" v-model="password1">
                        </div>
                    </div>

                    <div class="field">
                        <label>Repeat password</label>
                        <div class="control">
                            <input type="password" name="password2" class="input" v-model="password2">
                        </div>
                    </div>

                    <input type="checkbox" id="terms" v-model="termsChecked" />
                    <label for="terms"> I have read and agree to the <a href="/pub/terms">Terms of service</a></label>

                    <div class="notification is-danger" v-if="errors.length">
                        <p v-for="error in errors" v-bind:key="error">{{ error }}</p>
                    </div>

                    <div class="field">
                        <div class="control">
                            <button :disabled="!termsChecked" class="button is-success">Submit</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    import {toast} from 'bulma-toast'

    export default {
        name: 'SignUp',
        data() {
            return {
                username: '',
                //email: '',
                password1: '',
                password2: '',
                termsChecked: false,
                errors: [],
                checkMail: false,
            }
        },
        methods: {
            async submitForm() {
                this.errors = []

                if (this.username === '') {
                    this.errors.push('The username is missing')
                }

                if (this.password1 === '') {
                    this.errors.push('The password is too short')
                }

                if (this.password1 !== this.password2) {
                    this.errors.push('The password are not matching')
                }

                if (!this.errors.length) {
                    this.$store.commit('setIsLoading', true)

                    const formData = {
                        username: this.username,
                        password: this.password1,
                        email: this.username
                    }

                    await axios
                        .post('/lms/users/', formData)
                        .then(response => {
                            // console.log(response)
                            /*
                            toast({
                                message: 'E-mail with activation link was sent. If not arrived, please check SPAM',
                                type: 'is-warning',
                                dismissible: true,
                                pauseOnHover: true,
                                duration: 60000,
                                position: 'center',
                            })

                            this.$router.push('/log-in')
                            */
                            this.$router.push('/confirm-email')
                        })
                        .catch(error => {
                            if (error.response) {
                                for (const property in error.response.data) {
                                    this.errors.push(`${property}: ${error.response.data[property]}`)
                                }
                            } else if (error.message) {
                                this.errors.push('Something went wrong. Please try again!')
                            }
                        })
                    
                    this.$store.commit('setIsLoading', false)
                }
            }
        }
    }
</script>